import { render, staticRenderFns } from "./aReputationReviewsGraph.vue?vue&type=template&id=25671ea2&scoped=true"
import script from "./aReputationReviewsGraph.vue?vue&type=script&lang=js"
export * from "./aReputationReviewsGraph.vue?vue&type=script&lang=js"
import style0 from "./aReputationReviewsGraph.vue?vue&type=style&index=0&id=25671ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25671ea2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
